module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/905d59839c3500a2549d979989125a20.png";